import { persistStore } from 'redux-persist'
import { injectStore } from '../shared/interceptors'
import { Store } from './store'
import { userActions } from './reducers/user'

injectStore(Store, userActions)

export const persistor = persistStore(Store)
